<template>

    <div :class="{'box_bill_list_0': top===0, 'box_bill_list': top === undefined}" v-if="billInfo">
      <div v-if="deliverContractList.length>0" class="bd_2">
        <div class="submain"  @click="deliverIsOpen = !deliverIsOpen">
          <span class="consumptionDetails">交付明细</span>
          <div class="CenRadioIconWrap_2">
            <svg v-if="deliverIsOpen" class="CenRadioIcon_2" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M981.333333 512c0-260.266667-209.066667-469.333333-469.333333-469.333333S42.666667 251.733333 42.666667 512s209.066667 469.333333 469.333333 469.333333 469.333333-209.066667 469.333333-469.333333z m-64 0c0 221.866667-179.2 405.333333-405.333333 405.333333S106.666667 733.866667 106.666667 512 285.866667 106.666667 512 106.666667s405.333333 183.466667 405.333333 405.333333z" fill="#929292" /><path d="M512 473.6L345.6 640 298.666667 597.333333l213.333333-213.333333 213.333333 213.333333-46.933333 42.666667z" fill="#929292" /></svg>
            <svg v-else class="CenRadioIcon_2" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M42.666667 512c0 260.266667 209.066667 469.33333301 469.333333 469.333333S981.333333 772.266667 981.333333 512s-209.066667-469.33333301-469.333333-469.333333-469.33333301 209.066667-469.333333 469.333333z m63.99999999 0c0-221.86666699 179.19999999-405.333333 405.33333301-405.33333301S917.333333 290.133333 917.33333301 512 738.133333 917.333333 512 917.33333301s-405.333333-183.466667-405.33333301-405.33333301z" fill="#929292" /><path d="M512 550.4L678.4 384 725.333333 426.666667l-213.333333 213.333333-213.333333-213.333333 46.933333-42.666667z" fill="#929292" /></svg>
          </div>
        </div>
        <div class="subrow" @click="showBillInfo(deliverContract, '交付')" v-if="deliverIsOpen" v-for="deliverContract in deliverContractList">
          <div class="empty" />
          <div class="color" />
          <div class="colorDiv" />
          <span class="info">{{deliverContract.contractName}}</span>
          <div class="block_3">
            <div class="block_4">
              <span class="contractNumber">合同编号：{{deliverContract.contractNo}}</span>
              <span class="contractNumber">下单时间：{{deliverContract.deliveryDT}}</span>
              <span class="contractNumber">合同金额：¥{{deliverContract.contractMoney && splitMoney(deliverContract.contractMoney.toFixed(2))}}</span>
            </div>
            <svg t="1583809028111" class="arrow-right" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
          </div>
          <span class="money_3 research-font-color">待付尾款：¥{{deliverContract.waitRetainage && splitMoney(deliverContract.waitRetainage.toFixed(2))}}</span>
        </div>
      </div>
      <div v-if="consumeContractList.length>0" class="bd_2">
        <div class="submain" @click="consumeIsOpen = !consumeIsOpen">
          <span class="consumptionDetails">消费明细</span>
          <div class="CenRadioIconWrap_2">
            <svg v-if="consumeIsOpen" class="CenRadioIcon_2" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M981.333333 512c0-260.266667-209.066667-469.333333-469.333333-469.333333S42.666667 251.733333 42.666667 512s209.066667 469.333333 469.333333 469.333333 469.333333-209.066667 469.333333-469.333333z m-64 0c0 221.866667-179.2 405.333333-405.333333 405.333333S106.666667 733.866667 106.666667 512 285.866667 106.666667 512 106.666667s405.333333 183.466667 405.333333 405.333333z" fill="#929292" /><path d="M512 473.6L345.6 640 298.666667 597.333333l213.333333-213.333333 213.333333 213.333333-46.933333 42.666667z" fill="#929292" /></svg>
            <svg v-else class="CenRadioIcon_2" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M42.666667 512c0 260.266667 209.066667 469.33333301 469.333333 469.333333S981.333333 772.266667 981.333333 512s-209.066667-469.33333301-469.333333-469.333333-469.33333301 209.066667-469.333333 469.333333z m63.99999999 0c0-221.86666699 179.19999999-405.333333 405.33333301-405.33333301S917.333333 290.133333 917.33333301 512 738.133333 917.333333 512 917.33333301s-405.333333-183.466667-405.33333301-405.33333301z" fill="#929292" /><path d="M512 550.4L678.4 384 725.333333 426.666667l-213.333333 213.333333-213.333333-213.333333 46.933333-42.666667z" fill="#929292" /></svg>
          </div>
        </div>
        <div class="subrow" @click="showBillInfo(consumeContract, '消费')" v-if="consumeIsOpen" v-for="consumeContract in consumeContractList">
          <div class="empty" />
          <div class="color" />
          <div class="colorDiv" />
          <span class="info">{{consumeContract.contractName}}</span>
          <div class="block_3">
            <div class="block_4">
              <span class="contractNumber">合同编号：{{consumeContract.contractNo}}</span>
              <span class="contractNumber">下单时间：{{consumeContract.contractStartDT}}</span>
              <span class="contractNumber">合同金额：¥{{consumeContract.contractMoney && splitMoney(consumeContract.contractMoney.toFixed(2))}}</span>
            </div>
            <svg t="1583809028111" class="arrow-right" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
          </div>
          <span class="money_3 research-font-color">待付账户余额：¥{{consumeContract.waitPrepayAmount && splitMoney(consumeContract.waitPrepayAmount.toFixed(2))}}</span>
        </div>
      </div>
      <div style="height: 10vw;visibility: hidden;">hidden</div>
      <BillDetail v-if="showBillDetail" :selected="selected" :type="type" :contractInfo="contractInfo" @toggleShow="showBillDetail=!showBillDetail"/>
    </div>

</template>
<script>
// import {mapGetters} from 'vuex'
// import EMKT from '../../../../emkt'
import BillDetail from './BillDetail'

export default {
  data () {
    return {
      deliverIsOpen: false,
      consumeIsOpen: false,
      contractInfo: {},
      selected: '累计',
      type: '',
      showBillDetail: false
    }
  },
  components: {
    BillDetail
  },
  props: [
    'billInfo', 'top'
  ],
  computed: {
    deliverContractList () {
      if (this.billInfo && this.billInfo.deliverContractList) return this.billInfo.deliverContractList
      return {}
    },
    consumeContractList () {
      if (this.billInfo && this.billInfo.consumeContractList) return this.billInfo.consumeContractList
      return {}
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    showBillInfo (detail, type) {
      this.contractInfo = detail
      this.type = type
      this.showBillDetail = !this.showBillDetail
      console.log('detail', detail)
    }
  }
}
</script>
<style scoped>
.box_bill_list_0 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  /*height: 100vh;*/
  margin-bottom: 20vw;
  top: 0;
}
.box_bill_list {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  background-color: #efeef3;
  width: 100vw;
  /*height: 100vh;*/
  top: 14.93vw;
  margin-bottom: 20vw;
}

.bd_2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  /*margin-left: auto;*/
  /*margin-right: auto;*/
  /*margin-top: 6.67vw;*/
  border-radius: 2.67vw;
  /*background-color: #ffffff;*/
  width: 86.67vw;
  /* height: 37.33vw; */
  flex-shrink: 0;
}

.submain {
  box-sizing: border-box;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 6.67vw;
  border-radius: 2.67vw;
  background-color: #ffffff;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
  height: 13.33vw;
  flex-shrink: 0;
}

.consumptionDetails {
  opacity: 1;
  width: 12.8vw;
  height: 4.53vw;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 500;
}

.CenRadioIconWrap_2 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 4.27vw;
  height: 4.27vw;
}

.CenRadioIcon_2 {
  position: relative;
  width: 4.27vw;
  height: 4.27vw;
}

.empty {
  position: absolute;
  top: 0vw;
  left: 2.67vw;
  border-top-width: 1px;
  border-top-style: dashed;
  border-top-color: rgba(239, 238, 243, 1);
  width: 81.33vw;
  height: 0.53vw;
}

.color {
  position: absolute;
  top: -2.67vw;
  right: -2.67vw;
  border-radius: 5.33vw;
  background-color: #efeef3;
  width: 5.33vw;
  height: 5.33vw;
}

.colorDiv {
  position: absolute;
  top: -2.67vw;
  left: -2.67vw;
  border-radius: 5.33vw;
  background-color: #efeef3;
  width: 5.33vw;
  height: 5.33vw;
}

.subrow {
  display: flex;
  position: relative;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  height: 36vw;
  padding: 3vw 0;
  flex-shrink: 0;
}

.info {
  opacity: 1;
  margin-left: 6.67vw;
  max-width: 76.8vw;
  height: 4.53vw;
  overflow: hidden;
  -webkit-overflow-scrolling:touch;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3vw;
  font-weight: 400;
}

.block_3 {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  /*margin-top: 3.2vw;*/
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
  height: 15vw;
}
.block_4 {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;
  width: 86.67vw;
  height: 15vw;
}
.arrow-right {
  width: 5vw;
  height: 4vw;
}
.contractNumber {
  margin-top: 2vw;
  opacity: 1;
  width: 31.47vw;
  height: 3.73vw;
  line-height: 3.73vw;
  white-space: nowrap;
  color: #979797;
  font-size: 3vw;
  font-weight: 400;
}


.money_3 {
  opacity: 1;
  margin-top: 2vw;
  margin-right: 10vw;
  width: 36.27vw;
  /*height: 4.53vw;*/
  text-align: right;
  /*line-height: 4.53vw;*/
  white-space: nowrap;
  /*color: #5878fa;*/
  font-size: 3vw;
  font-weight: 400;
  align-self: flex-end;
}

</style>



// WEBPACK FOOTER //
// BillList.vue?cc391a68